// Input: a text field. Monospace by default (repo names, IDs); `sans` for words (names, emails).
// Ported from the Humint Assistant's components/ui/input.tsx.
import type { ComponentProps } from 'react';
import { cn } from './cn';

export interface InputProps extends ComponentProps<'input'> {
  sans?: boolean;
}

export const inputClass =
  'h-[34px] w-full rounded border border-hairline-strong bg-page px-2.5 text-ink-display' +
  ' focus:outline-2 focus:-outline-offset-1 focus:outline-focus-ring disabled:cursor-not-allowed disabled:opacity-60' +
  ' coarse:min-h-10 coarse:text-[16px]';

export function Input({ sans, className, ...props }: InputProps) {
  return (
    <input
      className={cn(inputClass, sans ? 'font-sans text-[13px]' : 'font-mono text-[12px]', className)}
      {...props}
    />
  );
}

/** Multiline source text, using the same focus, disabled and touch styles as Input. */
export function Textarea({ className, ...props }: ComponentProps<'textarea'>) {
  return <textarea className={cn(
    'min-h-[128px] w-full resize-y rounded border border-hairline-strong bg-page px-2.5 py-2 font-mono text-[12px] text-ink-display',
    'focus:outline-2 focus:-outline-offset-1 focus:outline-focus-ring disabled:cursor-not-allowed disabled:opacity-60 coarse:text-[16px]',
    className,
  )} {...props} />;
}
